export default "__VITE_ASSET__hHlMrQ2M__"